<template>
  <modal v-model="aboutModal" width="400" :footer-hide="true">
    <div class="about-modal">
      <logo :centered="true" />
      <div class="about-modal__info ms-text">
        Система управления договорной документацией, разработанная для компании
        ООО "ИнжГео"
      </div>
      <div class="about-modal__version">
        <span class="ms-help"> Сервисы: v.{{ apiVersion }} </span>
        <span class="ms-help"> Клиент: v.{{ frontVersion }} </span>
      </div>
      <div class="about-modal__made-by ms-small-head">
        <span>Made by David Asatryan and Igor Yaitsky, 2020</span>
      </div>
      <ul class="about-modal__contacts">
        <li class="about-modal__contact">
          <span class="about-modal__contact-label ms-text">
            Telegram:
          </span>
          <a href="https://t.me/igoryaitsky" class="about-modal__contact-link">@igoryaitsky</a>
        </li>
        <li class="about-modal__contact">
          <span class="about-modal__contact-label ms-text">
            Instagram:
          </span>
          <a href="https://instagram/igoryaitsky" class="about-modal__contact-link">@igoryaitsky</a>
        </li>
        <li class="about-modal__contact">
          <span class="about-modal__contact-label ms-text">
            Email:
          </span>
          <a href="mailto:yaickiu@gmail.com" class="about-modal__contact-link">yaickiu@gmail.com</a>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
import Logo from '@/components/logo/logo'

export default {
  components: {
    Logo
  },
  data () {
    return {
      apiVersion: '',
      frontVersion: ''
    }
  },
  computed: {
    aboutModal: {
      get () {
        return this.$store.state.aboutModal
      },
      set (value) {
        this.$store.commit('SET_ABOUT_MODAL', value)
      }
    }
  },
  methods: {
    async getData () {
      try {
        const url = 'page/version'
        const {
          backend_version,
          frontend_version
        } = await this.$store.dispatch('GET_REQUEST', { url })

        if (backend_version && frontend_version) {
          this.apiVersion = backend_version.replace(/\s+/g, '')
          this.frontVersion = frontend_version.replace(/\s+/g, '')
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.about-modal {
  padding: 32px 0 16px;

  .app-logo {
    &__icon {
      font-size: 32px !important;
    }
    &__text {
      font-size: 24px;
    }
  }

  &__info {
    margin-top: 16px;
    text-align: center;
    font-size: 14px;
  }

  &__version {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;

    .ms-help {
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
  }

  &__made-by {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
  }

  &__contacts {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;
    list-style-type: none;

    li {
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
  }
}
</style>
